import { render, staticRenderFns } from "./DeleteFormProfile.vue?vue&type=template&id=0d2c76ec&scoped=true"
import script from "./DeleteFormProfile.vue?vue&type=script&lang=js"
export * from "./DeleteFormProfile.vue?vue&type=script&lang=js"
import style0 from "./DeleteFormProfile.vue?vue&type=style&index=0&id=0d2c76ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2c76ec",
  null
  
)

export default component.exports